import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Map } from '../../components';

import css from './ListingPageLocation.module.css';
import { Card } from '../../components/Card/Card';
import Icon from '../../components/Icon/Icon';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { geolocation, publicData, listingId, mapsConfig } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <Card>
        <div className={css.wrapper}>
          <div className={css.header}>
            <Icon icon={'MapMark'} />
            <FormattedMessage id="ListingPage.locationTitle" />
          </div>
          {this.state.isStatic ? (
            <button
              className={css.map}
              onClick={() => {
                this.setState({ isStatic: false });
              }}
            >
              {map}
            </button>
          ) : (
            <div className={css.map}>{map}</div>
          )}
        </div>
      </Card>
    );
  }
}

export default SectionMapMaybe;
